export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_SUBSCRIPTION_DATA = "UPDATE_SUBSCRIPTION_DATA";
export const ACTIVE_SUBSCRIPTION = "ACTIVE_SUBSCRIPTION";